import { Div, Collection, RefString, DestroyingContentSwitcher, Select, Line, Snack } from "@tblabs/truffle";
import { Order } from "../../Models/Order";
import { AuthService } from "../../Services/Auth/AuthService";
import { OrdersManager } from "../../Services/OrdersManager";
import { Router } from "../../Services/Router";
import { AgentToDoView } from "./AgentToDoView";
import { BigHeader } from "../../Components/Utils/SmallHeader";
import { AgentsProvider } from "../../Services/AgentsProvider";


export class AgentOrdersViewPage extends Div
{
    constructor(
        private _manager: OrdersManager, 
        private _router: Router, 
        private _auth: AuthService, 
        private _agents: AgentsProvider,
        private agentId: string)
    {
        super("AdminPage");

        this.Append(`Ładowanie zadań Agenta ${this.agentId}...`);
    }

    protected async OnAppend(): Promise<void>
    {
        try
        {
            if (!this._auth.IsAuthorized)
            {
                this.Append(`Brak autoryzacji. Przekierowuję do strony logowania Agenta...`);
                window.location.hash = "agent/login";
                window.location.reload();
                return;
            }

            const orders: Order[] = await this._manager.GetAll("Current");
            orders.forEach(x => x.SelfSetup());

            const ordersCollection = new Collection(orders);

            this.Clear().Append(
                new BigHeader(`Zamówienia Agenta ${this.agentId}`),
                new Div().ClearBoth(),
                new Line(),
                new AgentToDoView(this._router, this._manager, this._auth, this._agents, ordersCollection, this.agentId)
            );
        }
        catch (ex: any)
        {
            new Snack(`❌ Wystąpił błąd podczas ładowania zamówień`, ex.message, { autoCloseTimeout: 0 });
            console.error(ex);
        }
    }
}
